<h3 class="title configurator-title">{{ 'closet-doors.range.title' | translate }}</h3>

@if (ranges !== null) {
  <section class="config-container shadow">
    <ul class="range-cards-container">
      @for (range of ranges; track range.id) {
        <li>
          <ng-casto-selection-card
            [imgSrc]="baseImgURL + range.icon"
            [label]="range.name"
            [active]="isRangeSelected(range.id)"
            (cardSelect)="selectRange(range)">
          </ng-casto-selection-card>
        </li>
      }
    </ul>
  </section>
} @else {
  <section class="config-container shadow">
    <ng-casto-loader></ng-casto-loader>
  </section>
}
